import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
export function useWatchSubscription(t0) {
  const $ = _c(5);
  const enabled = t0 === undefined ? true : t0;
  const apiFetcher = useApiFetcher();
  let t1;
  if ($[0] !== apiFetcher) {
    t1 = () => apiFetcher("/api/v1/payment/watch");
    $[0] = apiFetcher;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== enabled || $[3] !== t1) {
    t2 = {
      queryKey: QUERY_KEYS.WATCH_SUBSCRIPTION,
      queryFn: t1,
      enabled,
      refetchInterval: 3000,
      staleTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    };
    $[2] = enabled;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
}